var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fullWidthImageContainer",class:_vm.alignmentClass},[_c('img',{attrs:{"src":_vm.image.sizes['ct-extra-large']}})])
}
var staticRenderFns = []

export { render, staticRenderFns }